import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";
import type { STORE_ERROR_CODES } from "@amtana/store-contract";

// What a user reads when a store purchase fails (packages/module ADR-001).

const EN = {
  planRequiredTitle: "This add-on needs a higher plan",
  planRequiredDescription: "Upgrade your plan to add it.",
  incompatibleTitle: "This add-on isn't compatible with one you have",
  incompatibleDescription: "Cancel the other add-on first, then try again.",
  unknownTierTitle: "Select a plan",
  unknownTierDescription: "Pick one of the options to continue.",
  unknownProductTitle: "This add-on is not available",
  unknownProductDescription: "Go back to the store and choose another one.",
} as const;

const ES: Translation<typeof EN> = {
  planRequiredTitle: "Este complemento necesita un plan superior",
  planRequiredDescription: "Mejora tu plan para agregarlo.",
  incompatibleTitle: "Este complemento no es compatible con uno que ya tienes",
  incompatibleDescription: "Cancela primero el otro complemento e inténtalo de nuevo.",
  unknownTierTitle: "Elige un plan",
  unknownTierDescription: "Elige una de las opciones para continuar.",
  unknownProductTitle: "Este complemento no está disponible",
  unknownProductDescription: "Vuelve a la tienda y elige otro.",
};

export const STORE_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const STORE_ERROR_COPY = {
  store_plan_required: {
    title: phrase(STORE_ERROR_CATALOGS, "planRequiredTitle"),
    description: phrase(STORE_ERROR_CATALOGS, "planRequiredDescription"),
  },
  store_incompatible: {
    title: phrase(STORE_ERROR_CATALOGS, "incompatibleTitle"),
    description: phrase(STORE_ERROR_CATALOGS, "incompatibleDescription"),
  },
  store_unknown_tier: {
    title: phrase(STORE_ERROR_CATALOGS, "unknownTierTitle"),
    description: phrase(STORE_ERROR_CATALOGS, "unknownTierDescription"),
  },
  store_unknown_product: {
    title: phrase(STORE_ERROR_CATALOGS, "unknownProductTitle"),
    description: phrase(STORE_ERROR_CATALOGS, "unknownProductDescription"),
  },
} satisfies ErrorCopyFor<typeof STORE_ERROR_CODES>;
